import type { Env } from './types';

const SHARED_STATIC_FILES_PATH = '/webapps/shared';

const normalizeBaseUrl = (baseUrl: string) => {
  const withoutTrailingSlash = baseUrl.replace(/\/$/, '');
  return withoutTrailingSlash.endsWith(SHARED_STATIC_FILES_PATH)
    ? withoutTrailingSlash
    : `${withoutTrailingSlash}${SHARED_STATIC_FILES_PATH}`;
};

export const getStaticFilesURL = (
  env: Env,
  path: string,
  port = '3001',
  staticFilesBaseUrl?: string,
) => {
  const resolvedStaticFilesBaseUrl = staticFilesBaseUrl ?? process.env.STATIC_FILES_BASE_URL;

  if (resolvedStaticFilesBaseUrl) {
    return `${normalizeBaseUrl(resolvedStaticFilesBaseUrl)}/${path}`;
  }

  const ENVS = {
    development: `http://localhost:${port}`,
    qa: 'https://static-files.public.shared.qa.noths.com/webapps/shared',
    production: 'https://static-files.notonthehighstreet.com/webapps/shared',
  };
  return `${ENVS[env]}/${path}`;
};
